import { observer } from 'mobx-react-lite';
import { ReactElement, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useExportDataBl } from './ExportData.bl';
import { InformationModalContainer } from './ui/exportModal/InformationModal.container';
import { ExportDataFormContainer } from './ui/form/ExportDataForm.container';
import { ProjectExportsTableContainer } from './ui/table/ProjectExportsTable.container';

export const ExportDataContainer = observer((): ReactElement => {
  const bl = useExportDataBl();

  const { projectId } = useParams<{ projectId: string }>();

  useEffect(() => {
    void bl.initializeAsync(projectId);

    return (): void => {
      bl.cleanup();
    };
  }, []);

  return (
    <>
      <ExportDataFormContainer />
      <ProjectExportsTableContainer />
      <InformationModalContainer />
    </>
  );
});
